// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*RESPONSIVE VARIABLES*/
/*defined in breakpoints.scss*/
/* CONTAINER*/
/* BORDER*/
/* BOX SHADOW*/
/* FONT*/
/* BODY*/
/* SPACING*/
/* FORM*/
/* Footer Header*/
.miniMap {
  width: 100px;
}

.detail-kg {
  display: column;
  margin-bottom: 30px;
  min-height: 300px;
}
@media (min-width: 620px) {
  .detail-kg {
    display: flex;
  }
}
.detail-kg .info, .detail-kg .map {
  flex: 1;
}
.detail-kg .info-header {
  display: flex;
  word-break: break-all;
}
.detail-kg .info-header .logo {
  padding-right: 30px;
  max-width: 120px;
  display: flex;
  align-items: center;
}
.detail-kg .info-header .logo img {
  margin: auto;
  width: 100%;
}
.detail-kg .info-header .logo a {
  color: #0026a8;
}
.detail-kg .info p {
  word-break: break-all;
}
.detail-kg .info .address {
  color: black;
  word-wrap: break-word;
  margin-bottom: 10px;
}
.detail-kg .map {
  min-height: 100%;
  overflow: hidden;
  margin-left: 30px;
}
@media screen and (max-width: sm) {
  .detail-kg .map {
    height: 350px;
    margin: 0px;
  }
}
.detail-gallery .thumbs {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
}
.detail-gallery .thumbs .thumb {
  flex: 1;
  flex-basis: calc(25% - 20px);
  width: calc(25% - 20px);
  margin: 10px;
}
.detail-searchAround {
  color: #0050A8;
  margin-bottom: 30px;
  margin-left: 30px;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: normal;
  font-size: 150%;
  transition: font-weight 0.2s ease-in-out;
}
.detail-searchAround img {
  height: 50px;
  transform: scale(1);
  transition: transform 0.2s ease-in-out;
}
.detail-searchAround:hover {
  font-weight: bold;
}
.detail-searchAround:hover img {
  transform: scale(1.5);
  transition: transform 0.2s ease-in-out;
}
.detail-searchAround:hover span {
  margin-left: 30px;
}
.detail-searchAround span {
  margin-left: calc(30px / 2);
  transition: margin-left 0.2s ease-in-out;
}

main {
  padding-bottom: 30px;
}

:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/variables.scss","webpack://./src/app/pages/detail/detail.component.scss","webpack://./src/styles/breakpoints.scss"],"names":[],"mappings":"AAEA,uBAAA;AACA,8BAAA;AAEA,aAAA;AAIA,UAAA;AAKA,cAAA;AAOA,QAAA;AAOA,QAAA;AAKA,WAAA;AAIA,QAAA;AAIA,iBAAA;ACtCA;EACE,YAAA;AAQF;;AAJE;EACE,eAAA;EAIA,mBDsBQ;ECrBR,iBAAA;AAIJ;ACUI;EDpBF;IAGM,aAAA;EAWN;AACF;AAPI;EACI,OAAA;AASR;AALM;EACE,aAAA;EACA,qBAAA;AAOR;AANQ;EACE,mBDSE;ECRF,gBAAA;EAEA,aAAA;EACA,mBAAA;AAOV;AALU;EACE,YAAA;EACA,WAAA;AAOZ;AAJU;EACE,cAAA;AAMZ;AADM;EACE,qBAAA;AAGR;AAAM;EACE,YDjBgB;ECkBhB,qBAAA;EACA,mBAAA;AAER;AAEI;EACI,gBAAA;EACA,gBAAA;EACA,iBDtBI;ACsBZ;AAEQ;EALJ;IAMM,aAAA;IACA,WAAA;EACR;AACF;AAKI;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAHN;AAKM;EACE,OAAA;EACA,4BAAA;EACA,uBAAA;EACA,YAAA;AAHR;AAQE;EACE,cAAA;EAEA,mBDlDQ;ECmDR,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EAOA,wCAAA;AAdJ;AAQI;EACI,YAAA;EACA,mBAAA;EACA,sCAAA;AANR;AAWI;EACE,iBAAA;AATN;AAUM;EACE,qBAAA;EACA,sCAAA;AARR;AAUM;EACE,iBD1EI;ACkEZ;AAYI;EACE,2BAAA;EACA,wCAAA;AAVN;;AAeA;EACE,oBDrFU;ACyEZ;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAZF","sourcesContent":["@import \"definitions/colors\";\n\n/*RESPONSIVE VARIABLES*/\n/*defined in breakpoints.scss*/\n\n/* CONTAINER*/\n$container-max-width: 3200px;\n$container-secondary-max-width: 960px;\n\n/* BORDER*/\n$border-color: $brand-grey-dark;\n$border-radius: 6px;\n$border-radius--wide: 40px;\n\n/* BOX SHADOW*/\n$box-shadow-color: rgba($black, .1);\n$box-shadow-size: 3.2px 7.2px;\n$box-shadow--wide-size: 40px;\n$box-shadow: 0 3.2px 7.2px 0 $box-shadow-color;\n$box-shadow--wide: 0 0 $box-shadow--wide-size 0 $box-shadow-color;\n\n/* FONT*/\n$font-family: 'Montserrat', sans-serif;\n$font-family-secondary: 'Amatic SC', cursive;\n$font-size: 16px;\n$font-size-secondary: 26px;\n$font-weight: 300;\n\n/* BODY*/\n$body-color: $black;\n$body-color--secondary: black;\n$body-bg: $brand-pale;\n\n/* SPACING*/\n$padding-x: 30px;\n$padding-y: 30px;\n\n/* FORM*/\n$input-border-radius: calc(#{$border-radius--wide} / 3);\n$button-height: 50px;\n\n/* Footer Header*/\n$footerHeight:50px;\n$headerHeight:70px;\n\n\n\n","@import \"../../../styles/variables\";\n@import \"../../../styles/breakpoints\";\n\n.miniMap {\n  width: 100px;\n}\n\n.detail {\n  &-kg {\n    display: column;\n    @include media-breakpoint-up(sm) {\n        display: flex;\n    }\n    margin-bottom: $padding-y;\n    min-height: 300px;\n\n    .info, .map {\n        flex: 1;\n    }\n\n    .info {\n      &-header {\n        display: flex;\n        word-break: break-all;\n        .logo {\n          padding-right: $padding-x;\n          max-width: 120px;\n\n          display: flex;\n          align-items: center;\n\n          img {\n            margin: auto;\n            width: 100%;\n          }\n\n          a{\n            color: #0026a8;\n          }\n        }\n      }\n\n      p {\n        word-break: break-all;\n      }\n\n      .address {\n        color: $body-color--secondary;\n        word-wrap: break-word;\n        margin-bottom: 10px;\n      }\n    }\n\n    .map {\n        min-height: 100%;\n        overflow: hidden;\n        margin-left: $padding-x;\n\n        @media screen and (max-width: sm) {\n          height: 350px;\n          margin: 0px;\n        }\n    }\n  }\n\n  &-gallery {\n\n    .thumbs {\n      display: flex;\n      flex-wrap: wrap;\n      margin-left: -10px;\n      margin-right: -10px;\n\n      .thumb {\n        flex: 1;\n        flex-basis: calc(25% - 20px);\n        width: calc(25% - 20px);\n        margin: 10px;\n      }\n    }\n  }\n\n  &-searchAround {\n    color:#0050A8;\n    $transformTime:0.2s;\n    margin-bottom: $padding-y;\n    margin-left: 30px;\n\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    font-weight: normal;\n    font-size:150%;\n    img{\n        height:50px;\n        transform: scale(1);\n        transition: transform $transformTime ease-in-out;\n    }\n\n    transition: font-weight $transformTime ease-in-out;// bolt will change immediately after 0.2s\n\n    &:hover {\n      font-weight: bold;\n      img{\n        transform: scale(1.5);\n        transition: transform $transformTime ease-in-out;\n      }\n      span {\n        margin-left: $padding-x;\n      }\n    }\n\n    span {\n      margin-left: calc(#{$padding-x} / 2);\n      transition: margin-left $transformTime ease-in-out;\n    }\n  }\n}\n\nmain {\n  padding-bottom: $padding-y;\n}\n\n:host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n","// DELETE THIS CLASS\n\n$grid-breakpoints: (\n        xs: 0,\n        sm: 620px,\n        md: 768px,\n        lg: 992px,\n        xl: 1600px\n);\n\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
